import { normalizeRank, normalizeText } from './normalize';

export const isInvalidRankName = (rank) => {
  const r = normalizeRank(rank);
  return (
    r.includes('synonym')
    || r.includes('syn.')
    || r.includes(' syn ')
    || r === 'homonym'
    || r === 'invalid'
  );
};

export const getRecordStatus = (record) => {
  if (!record) return 'invalid';
  if (isInvalidRankName(record.current_rank)) return 'invalid';
  const invalidType = normalizeText(record.current_invalid_type);
  if (invalidType && invalidType !== 'valid') return 'invalid';
  return 'valid';
};
